{
  "id": "vw_group",
  "sources": "The main groups 0–9 that the parts catalogues of the Volkswagen Group's makes share: Porsche's PET and ETKA (Volkswagen, Audi, SEAT, Škoda, Cupra, Volkswagen Commercial Vehicles) are laid out alike. In a VW group part number (\"1J0 698 151 A\") the fourth character is the group; classic Porsche numbers (\"996.351.409.91\") don't carry it. Compiled in October 2026 from the PET groups as Porsche parts dealers list them (elferteile-ab-lager.de for the 964, 993 and 996, teile.com) and ETKA descriptions; the group names are the catalogues' own, shortened to workshop wording.",
  "groups": [
    { "number": "0", "name": { "en": "Accessories", "de": "Zubehör" } },
    { "number": "1", "name": { "en": "Engine", "de": "Motor" } },
    {
      "number": "2",
      "name": { "en": "Fuel, Exhaust, Cooling", "de": "Kraftstoff, Abgas, Kühlung" }
    },
    { "number": "3", "name": { "en": "Gearbox", "de": "Getriebe" } },
    { "number": "4", "name": { "en": "Front Axle, Steering", "de": "Vorderachse, Lenkung" } },
    { "number": "5", "name": { "en": "Rear Axle", "de": "Hinterachse" } },
    { "number": "6", "name": { "en": "Wheels, Brakes", "de": "Räder, Bremsen" } },
    { "number": "7", "name": { "en": "Pedals and Levers", "de": "Hebelwerk" } },
    { "number": "8", "name": { "en": "Body", "de": "Karosserie" } },
    { "number": "9", "name": { "en": "Electrics", "de": "Elektrik" } }
  ]
}
